import { render } from "./SettingsHeader.vue?vue&type=template&id=feee366c"
import script from "./SettingsHeader.vue?vue&type=script&lang=js"
export * from "./SettingsHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__